import { render } from "./CreatorLink.vue?vue&type=template&id=72bf187e"
import script from "./CreatorLink.vue?vue&type=script&lang=js"
export * from "./CreatorLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__